// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:58:40.644Z
// Property: Willows at the University (ID: 6767906449166458)
// Collections: 19 amenities, 14 floorplans (live), 24 photos, 49 POIs, 4 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166458",
  "property_external_id": "p8z6lmt",
  "property_zillow_url": "https://www.zillow.com/apartments/charlotte-nc/willows-at-the-university/CkBTGb/",
  "property_apartments_url": "https://www.apartments.com/willows-at-the-university-charlotte-nc/p8z6lmt/",
  "property_google_business_url": "https://www.google.com/maps/place/Willows+at+The+University/data=!4m2!3m1!1s0x0:0x606b08bbbe65d945?sa=X&ved=2ahUKEwin1Yiq5aeSAxW6qFYBHQYcMfAQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40249052687",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "997WUN",
  "property_status": null,
  "property_slug": "willows-at-the-university",
  "property_name": "Willows at the University",
  "property_website_url": "http://www.willowsattheuniversity.com/",
  "property_domain": "http://www.willowsattheuniversity.com/",
  "property_address": "625 Eltham Road",
  "property_full_address": "625 Eltham Rd, Charlotte, NC 28262",
  "property_address_1": "625 Eltham Rd",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": null,
  "property_address_zip": "28262",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Mallard Creek - Withrow Downs",
  "property_address_latitude": "35.3392238",
  "property_address_longitude": "-80.713472",
  "property_email": null,
  "property_phone": "(855) 481-6126",
  "property_call_tracking_phone": "855-481-6126",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Willows at the University in Charlotte, NC, choose from spacious one, two, and three-bedroom apartments adorned with modern finishes. Enjoy top-notch amenities like a resort-style pool, fitness center, and pet parks. Your ideal home awaits—check availability or schedule a tour to experience the vibrant lifestyle today!",
  "property_long_description": "Welcome to Willows at the University, your ideal apartment community nestled in the vibrant heart of Charlotte, NC! We offer a diverse selection of floor plans, including cozy one-bedroom, spacious two-bedroom, and expansive three-bedroom apartments, perfectly tailored to fit your lifestyle. Each residence features modern amenities such as fully equipped kitchens with stainless steel appliances, luxurious private patios or balconies, and generous walk-in closets—ensuring a perfect blend of comfort and style.\n\nRelax and recharge in our resort-style pool, or stay active and motivated in our state-of-the-art fitness center. For those who work from home, our business center is fully equipped to help you thrive, while our billiards table provides a fun way to unwind after a long day. Pet lovers will appreciate our dog spa and two pet parks, making it easy to enjoy life with your furry friends.\n\nLiving at Willows at the University means you're not just finding an apartment; you're joining a vibrant community in a fantastic neighborhood. Enjoy the convenience of being close to local dining, shopping, and entertainment options, all just a stone's throw from your front door. Our professional and responsive management team is always here to ensure you feel at home.\n\nDiscover a lifestyle tailored to your needs—browse our availability or schedule a tour today to find your new home at Willows at the University! Your new beginning awaits in Charlotte, NC!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f6b9b-d755-7225-9901-b573f3c4b99b.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a modern building in the background.",
    "public_id": "019f6b9b-d755-7225-9901-b573f3c4b99b",
    "storage_key": "property/6767906449166458/019f6b9b-d755-7225-9901-b573f3c4b99b.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166458/019ffc3c-6038-721e-9eb3-875b6c78f857.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3c-6038-721e-9eb3-875b6c78f857",
    "storage_key": "property/6767906449166458/019ffc3c-6038-721e-9eb3-875b6c78f857.m4v",
    "thumbnail_key": "property/6767906449166458/019ffc3c-6038-721e-9eb3-875b6c78f857_thumb.webp",
    "size_bytes": 39562968,
    "classification": "Community",
    "title": "Explore Our Premium Apartment Community Amenities",
    "description": "Discover the exceptional amenities at our apartment community, including a refreshing pool, a state-of-the-art fitness center, and beautifully designed common areas."
  },
  "property_total_units": "255",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": "34",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.15686274509804",
  "property_admin_fee": "250",
  "property_application_fee": "99",
  "property_fees_deposit_info": "Security Deposit\n$350-1st Month's Rent\n(refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome (up to 2 pets per unit).",
  "property_pet_policy_description": "Cats and dogs are welcome (up to 2 pets per unit). Pet deposit: $350 per pet. Monthly pet rent: $25 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://willowsattheuniversity.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcwillowsattheuniversity",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-add9-776f-8355-44fff023d0a4.webp",
  "property_primary_logo_media": {
    "alt_text": "Willows at the University logo",
    "public_id": "019d02d0-add9-776f-8355-44fff023d0a4",
    "storage_key": "property/6767906449166458/019d02d0-add9-776f-8355-44fff023d0a4.webp",
    "width": 274,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-98b0-72a1-8d2d-5b69cee9cb18.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02d0-98b0-72a1-8d2d-5b69cee9cb18",
    "storage_key": "property/6767906449166458/019d02d0-98b0-72a1-8d2d-5b69cee9cb18.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-bcd3-749d-b94e-8db417910265.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Willows at the University logo",
    "public_id": "019d02d0-bcd3-749d-b94e-8db417910265",
    "storage_key": "property/6767906449166458/019d02d0-bcd3-749d-b94e-8db417910265.webp",
    "width": 274,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-c457-70b5-b011-3e6d5b2869c0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Willows at The University logo",
    "public_id": "019d02d0-c457-70b5-b011-3e6d5b2869c0",
    "storage_key": "property/6767906449166458/019d02d0-c457-70b5-b011-3e6d5b2869c0.webp",
    "width": 274,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "735 - 1452",
  "property_sqft_min": "735",
  "property_sqft_max": "1452",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": "1849",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/WillowsUniversity",
  "property_instagram_url": "https://www.instagram.com/willowsuniversity",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ-SUJxBkdVIgRRdllvrsIa2A",
  "property_youtube_url": "https://www.youtube.com/watch?t=17&v=UPcv9mUZHKQ",
  "property_yelp_url": "https://www.yelp.com/biz/willows-at-the-university-by-rkw-residential-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Willows at the University",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Experience the vibrant lifestyle at Willows at the University in Charlotte, NC. Choose from thoughtfully designed one-, two-, or three-bedroom apartments featuring stainless steel appliances, spacious walk-in closets, and private patios. Revel in amenities like a resort-style pool, fitness center, and pet parks, creating the perfect blend of comfort and convenience.",
  "property_home_floorplans_blurb": "At Willows at the University in vibrant Charlotte, NC, our diverse floor plans cater to every lifestyle, offering one, two, and three-bedroom options. Each spacious layout is designed for comfort and convenience. Browse our available apartment homes today and envision your next chapter in a place you'll love to call home.",
  "property_home_gallery_blurb": "At Willows at the University in Charlotte, NC, your ideal home awaits with one, two, and three-bedroom floor plans designed for modern living. Enjoy resort-style amenities, from a refreshing pool to a lively billiards table, all within a vibrant neighborhood. Picture yourself living here and elevate your lifestyle today!",
  "property_home_neighborhood_blurb": "At Willows at the University in vibrant Charlotte, NC, choose from spacious one-, two-, and three-bedroom floor plans while enjoying a wealth of local gems. Dive into adventure at SEALIFE Charlotte-Concord, explore lush trails at Frank Liske Park, or unwind at the UNC Charlotte Botanical Gardens. Find your perfect home today! ",
  "property_home_reviews_blurb": "At Willows at the University in Charlotte, NC, residents revel in a vibrant community where “the staff is incredible” and “the apartments are beautiful.” With modern features and tranquil amenities, it’s no wonder so many are thrilled to call this their home. Experience the joy of living at Willows today!",
  "property_neighborhood_blurb": "At Willows at the University, life thrives amid a diverse array of attractions. Dive into adventure at SEA LIFE Charlotte-Concord, unwind in nature at Frank Liske Park, or enjoy spirited events at Jerry Richardson Stadium. Immerse yourself in a vibrant community with rich local experiences right at your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Willows at the University in Charlotte, NC, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, featuring stylish kitchens and private balconies. Enjoy resort-style amenities like a fitness center, billiards, dog spa, and more, all in a vibrant neighborhood filled with dining and entertainment options.",
  "property_applynow_blurb": "At Willows at the University in Charlotte, NC, choose from stylish one, two, or three-bedroom apartments tailored for your lifestyle. Enjoy resort-style amenities, including a sparkling pool, fitness center, and dog parks, all nestled in a vibrant neighborhood. Embrace comfort and convenience—lease your new home online today!",
  "property_contactus_blurb": "At Willows at the University in vibrant Charlotte, NC, our spacious one, two, and three-bedroom floor plans are designed for your comfort and style. Each layout offers a unique blend of modern amenities and inviting spaces. Have questions? Contact our leasing team today to find your perfect home!",
  "property_faqs_blurb": "At Willows at the University in vibrant Charlotte, NC, find the perfect home with our diverse floor plans: one, two, and three-bedroom apartments tailored to your lifestyle. Curious about our community? Our FAQs page is your go-to resource for all the information you need. Dive in today!",
  "property_floorplans_blurb": "At Willows at the University in Charlotte, NC, your ideal living space awaits. Choose from thoughtfully designed one, two, or three-bedroom apartment floor plans that cater to your lifestyle. Embrace comfort and convenience—browse our available homes today, and step into a haven that reflects your unique taste.",
  "property_gallery_blurb": "At Willows at the University in vibrant Charlotte, NC, our photo gallery captures the charm of our spacious one, two, and three-bedroom apartments. Imagine sunny days by the resort-style pool, energizing workouts in our fitness center, and cozy evenings on your private patio. Picture yourself living here—your perfect lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to Willows at the University in Charlotte, NC, where modern living meets vibrant community life. Choose from our spacious one, two, or three-bedroom floor plans, featuring stylish amenities like a resort-style pool, fitness center, and dog parks. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Willows at the University in vibrant Charlotte, NC, your furry friends are cherished! Bring along your cats and dogs—up to two per apartment—making every day a delightful adventure. Enjoy spacious living and a pet-friendly community, all just minutes from local attractions and the university itself!",
  "property_referafriend_blurb": "At Willows at the University in Charlotte, NC, every apartment is designed for comfort, with inviting one, two, and three-bedroom floor plans to suit your lifestyle. Great friends make great neighbors—refer a friend today and enjoy living in a vibrant community filled with connection and charm!",
  "property_residentaccess_blurb": "At Willows at the University in vibrant Charlotte, NC, choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Elevate your living experience with our resident portal—easily pay rent, schedule maintenance, and stay connected with your community in just a few clicks!",
  "property_reviews_blurb": "At Willows at the University in Charlotte, NC, residents rave about the \"great office staff\" and \"peaceful community.\" With modern apartment features and well-maintained amenities, it's no wonder why many choose to call this place home. Join a community where every day feels like a delight! ",
  "property_created_at": "1759782603927",
  "property_scheduletour_blurb": "At Willows at the University in vibrant Charlotte, NC, our thoughtfully designed one, two, and three-bedroom apartments cater to your unique lifestyle. Schedule a tour today and experience the perfect blend of comfort and community. Curious about resident life? Check out their testimonials for an insider's view of our welcoming atmosphere!",
  "property_thankyou_blurb": "Thank you for reaching out to Willows at the University in vibrant Charlotte, NC! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—offer the perfect home for every lifestyle. Stay tuned; a member of our team will connect with you soon to assist your apartment journey!",
  "property_virtualtours_blurb": "Step into the vibrant lifestyle at Willows at the University, nestled in the heart of Charlotte, NC. Our thoughtfully designed one, two, and three-bedroom floor plans cater to every need. Ready to envision your next home? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Willows at the University",
  "property_seo_title_home": "Apartments in Charlotte, NC | Willows at the University",
  "property_seo_description_home": "Willows at the University offers 1, 2, and 3-bedroom apartments in Charlotte, NC, featuring luxury interiors and pet-friendly amenities near UNC Charlotte.",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3-Bedroom Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Explore 1, 2, and 3-bedroom apartments for rent in Charlotte, NC at Willows at the University, featuring private balconies, chef-inspired kitchens, and more!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Apartments in Charlotte, NC",
  "property_seo_description_amenities": "Willows at the University offers resort-style amenities, including a pool, fitness center, dog spa, two pet parks, business center, billiards table, and more!",
  "property_seo_title_gallery": "Gallery | Apartments for Rent in Charlotte, NC",
  "property_seo_description_gallery": "View photos of Willows at the University apartments in Charlotte, NC, showcasing modern interiors, luxury amenities, and designer finishes.",
  "property_seo_title_virtualtours": "Virtual Tour | Apartments Close to UNC Charlotte",
  "property_seo_description_virtualtours": "Take a virtual tour of Willows at the University to explore 1–3-bedroom apartments in Charlotte, NC, and experience apartment living near UNC Charlotte.",
  "property_seo_title_interactivemap": "Interactive Map | Willows at the University Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Willows at the University in Charlotte—spacious layouts, resort-style amenities, and a vibrant community await!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near UNC Charlotte",
  "property_seo_description_neighborhood": "Willows at the University in Charlotte, NC, is near UNC Charlotte, Charlotte Motor Speedway, I-85, I-485, Reedy Creek Park, RibbonWalk Nature Preserve, & more!",
  "property_seo_title_contact": "Contact Us | Apartments in University Area, Charlotte, NC",
  "property_seo_description_contact": "Contact Willows at the University for information on 1, 2, and 3-bedroom apartments in Charlotte, NC, with modern interiors and resort-style amenities.",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Find the answers you need about Willows at the University in Charlotte, NC. From amenities to floor plans, our FAQs page has what you’re looking for!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Experience life at Willows at the University in Charlotte! Hear what residents love about our spacious apartments, stunning amenities, and vibrant community.",
  "property_seo_title_applynow": "Apply Now | Apartment Living in Charlotte, NC",
  "property_seo_description_applynow": "Apply now for 1, 2, and 3-bedroom apartments at Willows at the University in Charlotte, NC, featuring modern interiors and resort-style amenities.",
  "property_seo_title_residentaccess": "Resident Access | Apartments for Rent in Charlotte, NC",
  "property_seo_description_residentaccess": "Access your resident portal at Willows at the University Apartments in Charlotte, NC, for maintenance requests, rent payments, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Willows at the University",
  "property_seo_description_referafriend": "Refer a friend to Willows at the University in Charlotte, NC! Great friends make great neighbors—share the joy of your apartment community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments Near UNC Charlotte, NC",
  "property_seo_description_scheduletour": "Schedule a tour of Willows at the University to explore 1, 2, and 3-bedroom apartments in Charlotte, NC, with resort-style amenities near UNC Charlotte.",
  "property_seo_title_privacy": "Privacy Policy | Charlotte Apartments for Rent",
  "property_seo_description_privacy": "Discover how we protect your privacy on our website. Read our privacy policy for more details and learn about our apartments for rent in Charlotte, NC.",
  "property_seo_title_accessibility": "Accessibility | Apartments in Charlotte, NC",
  "property_seo_description_accessibility": "Explore our accessibility page to see how we made our Charlotte apartment website user-friendly for everyone.",
  "property_seo_title_sitemap": "Sitemap | Apartments for Rent in Charlotte, NC",
  "property_seo_description_sitemap": "Navigate our website with ease. Check out our sitemap to find all the information you need and your new apartment in Charlotte, NC.",
  "property_seo_title_thankyou": "Thank You | Charlotte Apartments for Rent",
  "property_seo_description_thankyou": "Thank you for your interest in Willows at the University. We'll process your request and assist you in finding your new apartment in Charlotte, NC.",
  "property_seo_title_pets": "Pet Policy | Pet-Friendly Apartments in Charlotte, NC",
  "property_seo_description_pets": "Willows at the University Apartments in Charlotte, NC, welcomes pets and offers amenities like a bark park and pet spa for your furry companions.",
  "property_updated_at": "1786643247615",
  "amenities": [
    {
      "id": "custom_367409bd-c548-4e2f-b3c6-04cb651ca16e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_25b3c297-72e1-4833-9efa-076e142df62f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2e1a7887-6e04-461a-a251-3d3cfd9137d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Billiards Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_13607080-91c2-4ccc-ae54-699ad5d3b24a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2cb7d64e-0ab5-4775-900d-df8ec9692a7c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_308a76c4-08c5-4c3b-a35d-19c2ea6b8cf7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_45e52b4f-1733-4b45-b853-3f9243afc2b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Two Pet Parks",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_397df3c5-4320-46fc-a662-88abe643f7a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Professional & Responsive Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_fea20ab7-c4cd-47a5-ac93-b9a691307fec",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Great Neighborhood",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e8fd2d62-d805-4b46-b180-5de929a36389",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Close to Local Dining, Shopping, & Entertainment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_62b6309c-dfc5-46dc-92c3-8d6d1a9a85a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2858e5fa-0070-41e3-ad2a-a4d8c1d68efb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio / Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c4e107ae-82ca-4826-a59c-a2b5731c1d0d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_743778d7-b910-46fe-80f4-c7ce9d53f77e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_960e668a-31a7-4150-8de0-89cf38823efb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Walk In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_408f0661-d974-422b-a1ef-1cc05161d115",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Islands*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_08ebf884-d885-45a0-aa96-017a79dc86f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantry and Linen Closets*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2ac86796-1c77-432b-be99-cc9538fdbf28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plank Inspired Flooring*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_45b89c71-9092-423a-8f44-1f47cac0dd0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_78210b6f-1c82-4f83-bf8c-cc8d07daba4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-515f-71e8-bdbd-90896883fa4f.webp",
      "image_media": {
        "alt_text": "Monument sign for Willows at the University, with landscaping and apartment buildings in the background.",
        "public_id": "01a016c2-515f-71e8-bdbd-90896883fa4f",
        "storage_key": "property/6767906449166458/01a016c2-515f-71e8-bdbd-90896883fa4f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Willows at the University, a beautiful apartment community surrounded by lush greenery and modern apartment buildings.",
      "link": "",
      "alt_text": "Monument sign for Willows at the University, with landscaping and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb620193-de77-4bc0-82bd-0e2f273bfdaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-5ac1-70c9-8b24-d4ccb5462f98.webp",
      "image_media": {
        "alt_text": "Aerial view of modern apartment buildings with a resort-style pool and lush green surroundings At Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-5ac1-70c9-8b24-d4ccb5462f98",
        "storage_key": "property/6767906449166458/01a016c2-5ac1-70c9-8b24-d4ccb5462f98.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover vibrant living at this apartment community, featuring a sparkling pool and beautiful landscaping, offering a serene escape.",
      "link": "",
      "alt_text": "Aerial view of modern apartment buildings with a resort-style pool and lush green surroundings At Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2783efe8-0bc5-43f3-80e9-1ccaf1fe2b8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-629e-763b-8ec6-bc7fd230f778.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and trees at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-629e-763b-8ec6-bc7fd230f778",
        "storage_key": "property/6767906449166458/01a016c2-629e-763b-8ec6-bc7fd230f778.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring balconies, large windows, and lush green trees under a bright blue sky.",
      "link": "",
      "alt_text": "Exterior of apartment building with balconies and trees at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5023914d-7af0-4bb7-9652-c4b29f166d9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-55aa-74e0-9dfc-c077edd405ae.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment building exterior with blue and grey accents and balconies, surrounded by trees at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-55aa-74e0-9dfc-c077edd405ae",
        "storage_key": "property/6767906449166458/01a016c2-55aa-74e0-9dfc-c077edd405ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our stunning apartment community, featuring modern architecture and lush green surroundings. Enjoy the convenience and comfort of this beautiful building.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment building exterior with blue and grey accents and balconies, surrounded by trees at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ebaa46d5-4b8f-4886-8138-a4acf90e3ed6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-0689-749a-8e52-027eb191c392.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and bar stools",
        "public_id": "01a016c2-0689-749a-8e52-027eb191c392",
        "storage_key": "property/6767906449166458/01a016c2-0689-749a-8e52-027eb191c392.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Sleek modern kitchen featuring a granite-topped island with bar stools, dark wood cabinetry, and stainless steel appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite island and bar stools",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_658a616c-094e-4b5a-8865-273530ab6253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-3041-76f8-8389-e82662b40337.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a large TV, comfortable seating, and contemporary art at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-3041-76f8-8389-e82662b40337",
        "storage_key": "property/6767906449166458/01a016c2-3041-76f8-8389-e82662b40337.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring ample seating, a large screen TV, and vibrant artwork. Perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern lounge area with a large TV, comfortable seating, and contemporary art at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b572a31b-a33a-48d3-a862-32355173d4ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-0cc0-76b1-a390-1195015f18ab.webp",
      "image_media": {
        "alt_text": "Community lounge with a pool table, seating areas, and pool views.",
        "public_id": "01a016c2-0cc0-76b1-a390-1195015f18ab",
        "storage_key": "property/6767906449166458/01a016c2-0cc0-76b1-a390-1195015f18ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community lounge featuring a pool table, comfortable seating, and scenic views of the resort-style pool.",
      "link": "",
      "alt_text": "Community lounge with a pool table, seating areas, and pool views.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be578c5d-39ad-4c8b-8dc7-319588154c35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-074e-759c-9726-b70de422c308.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating.",
        "public_id": "01a016c2-074e-759c-9726-b70de422c308",
        "storage_key": "property/6767906449166458/01a016c2-074e-759c-9726-b70de422c308.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a printer, to stay productive during your stay.",
      "link": "",
      "alt_text": "Business center with computers, printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0c53d5c2-9c12-4b94-8c6c-983ea1bde805",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-3027-7709-b7ca-9d08190c4096.webp",
      "image_media": {
        "alt_text": "Modern fitness center with punching bag, weight rack, and cardio machines at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-3027-7709-b7ca-9d08190c4096",
        "storage_key": "property/6767906449166458/01a016c2-3027-7709-b7ca-9d08190c4096.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a boxing station, free weights, and a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Modern fitness center with punching bag, weight rack, and cardio machines at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_504f4658-0933-4aec-87ea-5e39e9c08a68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-2694-72a1-a2ed-2311cd352d0f.webp",
      "image_media": {
        "alt_text": "Modern apartment complex fitness center with treadmills, ellipticals, and a stair climber.",
        "public_id": "01a016c2-2694-72a1-a2ed-2311cd352d0f",
        "storage_key": "property/6767906449166458/01a016c2-2694-72a1-a2ed-2311cd352d0f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and ample space for your workout routine.",
      "link": "",
      "alt_text": "Modern apartment complex fitness center with treadmills, ellipticals, and a stair climber.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e4c2cc3-ad93-4a7a-85f9-486fc2cee9bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-2694-72a1-a2ed-25ebe079f83d.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, cardio equipment, and large windows overlooking trees.",
        "public_id": "01a016c2-2694-72a1-a2ed-25ebe079f83d",
        "storage_key": "property/6767906449166458/01a016c2-2694-72a1-a2ed-25ebe079f83d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of weight machines, cardio equipment, and plenty of natural light. Work out with a view of the surrounding trees.",
      "link": "",
      "alt_text": "Fitness center with weight machines, cardio equipment, and large windows overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c94aa256-4afb-467f-aa9f-be50babdb696",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-0b29-737c-bfe8-0e26f1a55aa4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-0b29-737c-bfe8-0e26f1a55aa4",
        "storage_key": "property/6767906449166458/01a016c2-0b29-737c-bfe8-0e26f1a55aa4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Adjacent is our modern clubhouse, offering additional amenities.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c6b3dba0-c58f-4cd8-8751-9d3bc35ed7f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-266f-72b8-b81a-a18ab31846e4.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-266f-72b8-b81a-a18ab31846e4",
        "storage_key": "property/6767906449166458/01a016c2-266f-72b8-b81a-a18ab31846e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with comfortable lounge chairs and shaded umbrellas. A perfect oasis for unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be5327e6-75f7-4406-9d86-73e416881d0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-2632-707a-a52c-733122c494f3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas next to a modern building at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-2632-707a-a52c-733122c494f3",
        "storage_key": "property/6767906449166458/01a016c2-2632-707a-a52c-733122c494f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool, complete with comfortable lounge chairs and vibrant blue umbrellas, perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas next to a modern building at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7de6983-bf0a-4213-8323-3f3cf214f88f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-305c-7109-88a2-6cba210b320e.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-305c-7109-88a2-6cba210b320e",
        "storage_key": "property/6767906449166458/01a016c2-305c-7109-88a2-6cba210b320e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful resort-style pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_526e02cd-ea0d-4a32-8f16-1c6699e22be1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-302d-7528-9a38-f8d88b4a1409.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, benches, and grassy areas at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-302d-7528-9a38-f8d88b4a1409",
        "storage_key": "property/6767906449166458/01a016c2-302d-7528-9a38-f8d88b4a1409.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, complete with agility equipment and plenty of room for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment, benches, and grassy areas at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36a8e51a-6e43-40d2-add2-eb570d04c9fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-2fc5-73a1-ad03-a601b45552b0.webp",
      "image_media": {
        "alt_text": "Open concept living area with kitchen island and living room.",
        "public_id": "01a016c2-2fc5-73a1-ad03-a601b45552b0",
        "storage_key": "property/6767906449166458/01a016c2-2fc5-73a1-ad03-a601b45552b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with a granite island, comfortable living room, and a view of the bedroom.",
      "link": "",
      "alt_text": "Open concept living area with kitchen island and living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c36c800b-349a-4dab-989d-7f815283c6ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-338f-73a7-853d-fc36b2f9e942.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a016c2-338f-73a7-853d-fc36b2f9e942",
        "storage_key": "property/6767906449166458/01a016c2-338f-73a7-853d-fc36b2f9e942.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek dark wood cabinetry, a spacious granite island with bar seating, and top-of-the-line stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cac9912a-651d-49ab-8cca-ce6817cc391b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-59bc-733a-bbde-d2bae46545ed.webp",
      "image_media": {
        "alt_text": "Modern living room and open kitchen with island and bar stools.",
        "public_id": "01a016c2-59bc-733a-bbde-d2bae46545ed",
        "storage_key": "property/6767906449166458/01a016c2-59bc-733a-bbde-d2bae46545ed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area with a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and open kitchen with island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f98911c-6e91-4ca9-880c-b7450e3e389b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-4a0e-74c9-bbab-a957e084bf5a.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, chairs, coffee table, and TV at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-4a0e-74c9-bbab-a957e084bf5a",
        "storage_key": "property/6767906449166458/01a016c2-4a0e-74c9-bbab-a957e084bf5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room with modern furnishings, featuring a comfortable sofa, accent chairs, a glass coffee table, and a wall-mounted TV, opening to a patio.",
      "link": "",
      "alt_text": "Living room with a sofa, chairs, coffee table, and TV at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1544a0e-d4c8-4116-bec8-772903def991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-4ed9-73a9-a6f9-6c02f8a13ce7.webp",
      "image_media": {
        "alt_text": "King-size bed with white linens and decorative pillows in a bedroom with a desk and mirror.",
        "public_id": "01a016c2-4ed9-73a9-a6f9-6c02f8a13ce7",
        "storage_key": "property/6767906449166458/01a016c2-4ed9-73a9-a6f9-6c02f8a13ce7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a spacious king-size bed and elegant decor.",
      "link": "",
      "alt_text": "King-size bed with white linens and decorative pillows in a bedroom with a desk and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ed3e45f-e27b-44b3-84e9-0d468616d8b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-50ab-7758-a707-100f1f202cef.webp",
      "image_media": {
        "alt_text": "King size bed with white linens and dark accent pillows, nightstand with lamp, desk, and view into ensuite bathroom at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-50ab-7758-a707-100f1f202cef",
        "storage_key": "property/6767906449166458/01a016c2-50ab-7758-a707-100f1f202cef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king size bed, elegant decor, and an adjoining ensuite bathroom for ultimate convenience.",
      "link": "",
      "alt_text": "King size bed with white linens and dark accent pillows, nightstand with lamp, desk, and view into ensuite bathroom at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ae0aaae-21bb-471d-a33d-19af17e99781",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-4c9d-70f3-8bb3-4305b343ecb3.webp",
      "image_media": {
        "alt_text": "A spacious bedroom with a king-size bed, teal headboard, and modern decor at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-4c9d-70f3-8bb3-4305b343ecb3",
        "storage_key": "property/6767906449166458/01a016c2-4c9d-70f3-8bb3-4305b343ecb3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a king-size bed and stylish accents for a serene retreat.",
      "link": "",
      "alt_text": "A spacious bedroom with a king-size bed, teal headboard, and modern decor at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d51a5fe2-7955-4a9e-b0f7-7f79f3a80c20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/01a016c2-4dfb-7377-9df5-349d99fd4a1d.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop, vessel sink, and dark wood cabinets. Includes a toilet and a bathtub with a white ruffled shower curtain at Willows at the University in Charlotte, NC.",
        "public_id": "01a016c2-4dfb-7377-9df5-349d99fd4a1d",
        "storage_key": "property/6767906449166458/01a016c2-4dfb-7377-9df5-349d99fd4a1d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite-top vanity, a vessel sink, ample cabinet storage, and a clean white bathtub with a decorative shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom vanity with granite countertop, vessel sink, and dark wood cabinets. Includes a toilet and a bathtub with a white ruffled shower curtain at Willows at the University in Charlotte, NC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_69eb9f75-4c72-479e-a836-d9e8d39a7334",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Great Wolf Lodge | Concord",
      "poi_type": "Entertainment",
      "poi_address": "10175 Weddington Rd, Concord, NC 28027, USA",
      "poi_short_description": "Themed suites in a sprawling resort with free passes to the indoor water park plus kids' activities.",
      "poi_long_description": "People say this resort hotel offers a fun indoor water park with slides, a wave pool, and a lazy river, as well as an arcade, bowling, and laser tag. They also highlight the family-friendly atmosphere, the spacious rooms, and the friendly staff.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-5d6e-71d2-8e21-414a2477198f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5d6e-71d2-8e21-414a2477198f",
        "storage_key": "property/6767906449166458/019d02d0-5d6e-71d2-8e21-414a2477198f.webp",
        "width": 1280,
        "height": 803
      },
      "poi_business_url": "https://www.greatwolf.com/concord?utm_source=google&utm_medium=organic&utm_campaign=gmb-concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=1176379236566889740&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "great-wolf-lodge--concord",
      "poi_latitude": "35.3613868",
      "poi_longitude": "-80.71172729999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 866-925-9653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-846d-73fb-aff1-a29e1ff2b6d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-846d-73fb-aff1-a29e1ff2b6d9",
        "storage_key": "property/6767906449166458/019d02d0-846d-73fb-aff1-a29e1ff2b6d9.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJm6Y9Xl0bVIgRDPW21K5WUxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_7f7e724c-d724-4a2b-8c35-f51ff2fdee14",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "People say this amphitheatre offers a variety of seating options, including covered seats, lawn seats, and VIP experiences, and features a large outdoor space with picnic tables and free water. They also highlight the easy access, convenient parking, and friendly staff.\n\nSome reviews mention the drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-5a6a-7609-b338-afcd7a62b8dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5a6a-7609-b338-afcd7a62b8dc",
        "storage_key": "property/6767906449166458/019d02d0-5a6a-7609-b338-afcd7a62b8dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3271592",
      "poi_longitude": "-80.7123113",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_eb5ffa1c-9c50-48ef-9e9e-77d4b49c902f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Morrison Motor Car Museum",
      "poi_type": "Entertainment",
      "poi_address": "4545 Concord Pkwy S, Concord, NC 28027, USA",
      "poi_short_description": "Vintage & antique vehicles plus racing memorabilia showcased in a roomy space with a gift shop.",
      "poi_long_description": "People say this museum offers a wide selection of cars and automotive memorabilia, many of which are available for sale. They highlight the unique and rare items, and the ever-changing inventory. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-5a5e-777d-9f8e-1cc32d4e91f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5a5e-777d-9f8e-1cc32d4e91f4",
        "storage_key": "property/6767906449166458/019d02d0-5a5e-777d-9f8e-1cc32d4e91f4.webp",
        "width": 822,
        "height": 463
      },
      "poi_business_url": "http://www.morrisonmotorcarmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16796046795715783080&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "morrison-motor-car-museum",
      "poi_latitude": "35.3590299",
      "poi_longitude": "-80.6738745",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-788-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-846a-7342-8ed2-2b23d73f68b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-846a-7342-8ed2-2b23d73f68b6",
        "storage_key": "property/6767906449166458/019d02d0-846a-7342-8ed2-2b23d73f68b6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yhyLt4aVIgRqCl6SZKLF-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3220c126-f701-41d2-8e6f-33522ea07db7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Charlotte Motor Speedway Karting",
      "poi_type": "Entertainment",
      "poi_address": "Concord, NC 28027, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-5b93-7542-bd29-c6e8733f6199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-5b93-7542-bd29-c6e8733f6199",
        "storage_key": "property/6767906449166458/019d02d0-5b93-7542-bd29-c6e8733f6199.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12434873147564906961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charlotte-motor-speedway-karting",
      "poi_latitude": "35.354417",
      "poi_longitude": "-80.6816157",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmXJQNAAbVIgR0Vmmsz6Lkaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_2d152796-a399-477c-964f-e0cf906fa568",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Regal Starlight - Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "11240 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "People say this movie theater offers comfortable, reclining seats and fresh popcorn. They also highlight the friendly staff and the relaxing atmosphere.\n\nOther reviews mention the sound system can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-60d4-73ea-9123-3ef51674c655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-60d4-73ea-9123-3ef51674c655",
        "storage_key": "property/6767906449166458/019d02d0-60d4-73ea-9123-3ef51674c655.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-starlight-charlotte-1848?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3793897542016868716&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-starlight---charlotte",
      "poi_latitude": "35.33325",
      "poi_longitude": "-80.71723999999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-8466-7230-aadc-73cf9524756e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d0-8466-7230-aadc-73cf9524756e",
        "storage_key": "property/6767906449166458/019d02d0-8466-7230-aadc-73cf9524756e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_JJhCZ_WIgRbKEkqrahpjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2623c5c3-551c-40e6-8035-a55752c4d96f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "8181 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a huge selection of fishing, hunting, camping, and outdoor gear, as well as firearms, ammunition, and reloading supplies. They highlight the unique, themed atmosphere and the quality products. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-6174-7329-8c04-c7f89cbd52c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6174-7329-8c04-c7f89cbd52c6",
        "storage_key": "property/6767906449166458/019d02d0-6174-7329-8c04-c7f89cbd52c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/nc/concord/8181-concord-mills-blvd.html?y_source=1_MzAxMTQ5OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4436789771853565545&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "35.3672812",
      "poi_longitude": "-80.7191974",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-979-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSamihlkbVIgRaQ5rVsqkkj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_da2ccab1-049d-4928-a71f-53d8efc3a80f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "T.J. Maxx & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "8050 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "People say this department store offers a wide variety of housewares, furniture, decorative items, and clothing. They also highlight the great prices, good deals, and the clean and organized store.\n\nSome reviews mention there can be long checkout lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-6343-714c-be1c-8cc277b46148.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6343-714c-be1c-8cc277b46148",
        "storage_key": "property/6767906449166458/019d02d0-6343-714c-be1c-8cc277b46148.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1619219343109051060&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tj-maxx--homegoods",
      "poi_latitude": "35.3710975",
      "poi_longitude": "-80.7146849",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-971-0972",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVUxHylkbVIgRtNJ032mfeBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_122c4b70-6d5f-4d37-988d-a7363fb1d89a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8875 Christenbury Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide selection of merchandise, including bath towels, and has good sales. They also highlight the friendly, courteous, and helpful staff, and the convenient Amazon return kiosk.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-67e1-702b-94a9-3b85f93ec7be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-67e1-702b-94a9-3b85f93ec7be",
        "storage_key": "property/6767906449166458/019d02d0-67e1-702b-94a9-3b85f93ec7be.webp",
        "width": 1280,
        "height": 967
      },
      "poi_business_url": "https://www.kohls.com/stores/nc/concord-1525.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=9995828045454030733&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "35.373926",
      "poi_longitude": "-80.7337412",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-549-9847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyWH-vj0cVIgRjbcsraVQuIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_841db955-b52b-4231-9b08-117d554f5fbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Concord Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "8111 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Large mall with mostly outlet & big-box stores, plus a movie theater, restaurants & an aquarium.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including outlet stores, big brands, and specialty shops, with great deals. They also highlight the diverse and delicious food court options, and the clean, spacious, and easy-to-navigate layout.\n\nSome reviews mention the mall can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-694c-723d-b296-5c10cd05e99f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-694c-723d-b296-5c10cd05e99f",
        "storage_key": "property/6767906449166458/019d02d0-694c-723d-b296-5c10cd05e99f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/concord-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=15278858876011446672&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "concord-mills",
      "poi_latitude": "35.3690086",
      "poi_longitude": "-80.72197059999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-886-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpU5jZKccVIgRkIH8ZTJpCdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_034db565-dcda-48de-97da-781086e53681",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7735 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Grocery store, pharmacy, clothing, furniture, sporting goods, electronics, home goods and sporting goods retailer featuring clothing, housewares, electronics and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, household items, clothing, and electronics, and has reasonable prices.\n\nOther reviews mention the service can be slow and the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-6968-72fe-8a36-93cbbeceabbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6968-72fe-8a36-93cbbeceabbb",
        "storage_key": "property/6767906449166458/019d02d0-6968-72fe-8a36-93cbbeceabbb.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2134-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7693588847703310125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.2951583",
      "poi_longitude": "-80.7581024",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-547-0525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9wzzDDAcVIgRLT9Da0sexWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_864e354d-2702-4910-87c1-2938540793ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "Parking lot, 8435 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Diners say this restaurant serves up delicious wings, pizookie, and a wide selection of beers. They also highlight the friendly and attentive service, and many appreciate the great deals and specials.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-6c71-708e-9f7a-48beb260eb8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-6c71-708e-9f7a-48beb260eb8d",
        "storage_key": "property/6767906449166458/019d02d0-6c71-708e-9f7a-48beb260eb8d.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.bjsrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17878522490247606685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "35.3702706",
      "poi_longitude": "-80.7210994",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 980-777-7030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLW9LrCYbVIgRnXEK_HpFHfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_08c2959f-4aa8-4c0e-b88d-8017407c18dd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Desi District Concord",
      "poi_type": "Restaurants",
      "poi_address": "8524 Pit Stop Ct NW, Concord, NC 28027, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Indian restaurant serves delicious mutton dum biryani, chicken majestic, and curry leaf chicken. They also highlight the generous portion sizes, reasonable prices, and vibrant atmosphere.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-72ad-722f-a492-373aab2ad561.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-72ad-722f-a492-373aab2ad561",
        "storage_key": "property/6767906449166458/019d02d0-72ad-722f-a492-373aab2ad561.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.desidistrict.com/order/takeAway?location=concord",
      "poi_directions_map_url": "https://maps.google.com/?cid=9557322944689170639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "desi-district-concord",
      "poi_latitude": "35.373536",
      "poi_longitude": "-80.7226094",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 980-494-3374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_jyb8sdVIgRz2jj0ZRuooQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_a1504700-57e4-471b-ad1e-f0eeeeb51475",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Talkin' Tacos Concord",
      "poi_type": "Restaurants",
      "poi_address": "8915 Christenbury Pkwy, Concord, NC 28027, USA",
      "poi_short_description": "Relaxed, Mexican eatery, for tacos and burritos ranging from chicken, birria and steak to shrimp.",
      "poi_long_description": "People say this taco restaurant serves delicious birria tacos, quesadillas, and ramen. They highlight the generous portions, fresh ingredients, and flavorful dishes. They also like the fun, vibrant atmosphere and the friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02d0-734b-73a4-ae42-77bfebaeb910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d0-734b-73a4-ae42-77bfebaeb910",
        "storage_key": "property/6767906449166458/019d02d0-734b-73a4-ae42-77bfebaeb910.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://talkintacos.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12806170706575825619&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "talkin-tacos-concord",
      "poi_latitude": "35.3754064",
      "poi_longitude": "-80.7337115",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 980-983-7079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwnLwZwdVIgR0xp3WmiouLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_36c3b41e-14ea-43fa-a687-132c05254d99",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-0043-72fc-9d6f-0d38f87fd7ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-0043-72fc-9d6f-0d38f87fd7ad",
        "storage_key": "property/6767906449166458/019d02ce-0043-72fc-9d6f-0d38f87fd7ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_257b16b7-ed62-4551-8080-a94e00ae6b4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Charlotte Mecklenburg Library - University City Regional",
      "poi_type": "Education",
      "poi_address": "5528 Waters Edge Vlg Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Part of a 20-location county system, this spacious public library has ample parking.",
      "poi_long_description": "People say this public library offers a wide variety of materials and activities for children. They highlight the beautiful, new, state-of-the-art facility with quiet places to study and read, and views of the lake. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-0145-76ad-841a-7dd3e8a2713f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-0145-76ad-841a-7dd3e8a2713f",
        "storage_key": "property/6767906449166458/019d02ce-0145-76ad-841a-7dd3e8a2713f.webp",
        "width": 688,
        "height": 457
      },
      "poi_business_url": "http://www.cmlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387831292961257955&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "charlotte-mecklenburg-library---university-city-regional",
      "poi_latitude": "35.3107018",
      "poi_longitude": "-80.7514401",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-416-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRxlsdCEcVIgR43mw1gNsxUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ba5e7a5b-9f95-48fe-ba2c-28ebf08b185c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3024 Prosperity Church Rd A, Charlotte, NC 28269, USA",
      "poi_short_description": "Spacious health club chain providing classes, free weights, cardio equipment, and a personal trainer.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, a pool, a sauna, and a jacuzzi. They also highlight the spacious layout, modern equipment, and friendly staff.\n\nSome reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-1279-729c-98ba-2f22bd3432d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-1279-729c-98ba-2f22bd3432d6",
        "storage_key": "property/6767906449166458/019d02ce-1279-729c-98ba-2f22bd3432d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1314&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5303975230379288128&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "35.34348",
      "poi_longitude": "-80.76956",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-270-8616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0K3YZ8dVIgRQGY60F6Bm0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e41ce52b-3737-40df-bbee-7fe8455370d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8052 Concord Mills Boulevard, Concord, NC 28027, USA",
      "poi_short_description": "Clean destination providing a variety of beauty products (including fragrance and haircare) as well as a salon for haircuts and hair color.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-14d2-7188-b06b-8787b042f6aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-14d2-7188-b06b-8787b042f6aa",
        "storage_key": "property/6767906449166458/019d02ce-14d2-7188-b06b-8787b042f6aa.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/concord-nc-1531",
      "poi_directions_map_url": "https://maps.google.com/?cid=1874395844369652807&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.3725266",
      "poi_longitude": "-80.71679329999999",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-709-5606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrY_h3_gbVIgRRxwf6BYxAxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_488974d4-bed8-47a1-a9c9-deb454901cbc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "NP NAILS SPA",
      "poi_type": "Health and Wellness",
      "poi_address": "3020 Driwood Ct A, Charlotte, NC 28269, USA",
      "poi_short_description": "Family-run nail parlor offering acrylics, nail art, manicures, pedicures, and waxing services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-198f-7673-b75c-82766333dc68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-198f-7673-b75c-82766333dc68",
        "storage_key": "property/6767906449166458/019d02ce-198f-7673-b75c-82766333dc68.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://npnailspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12924921865111252840&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "np-nails-spa",
      "poi_latitude": "35.3408177",
      "poi_longitude": "-80.7699999",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-237-6002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSK_wsgdVIgRaK-iB_WLXrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_a4693912-e327-47f6-aec9-3bb571ce8583",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Gold's Gym Huntersville",
      "poi_type": "Health and Wellness",
      "poi_address": "13108-B Eastfield Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "Low-key health club with cardio classes, 24-hour access, free-weight circuits, a gym shop and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-1bb2-7129-99ca-f8daf26d7210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-1bb2-7129-99ca-f8daf26d7210",
        "storage_key": "property/6767906449166458/019d02ce-1bb2-7129-99ca-f8daf26d7210.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.goldsgym.com/huntersville-nc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1197517625463909821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym-huntersville",
      "poi_latitude": "35.3848953",
      "poi_longitude": "-80.7848358",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-274-1327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7DNJqUdVIgRva0Lhu9vnhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_379deabc-066c-4b2d-87d4-90e52adfd355",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Harrisburg Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "191 Sims Pkwy, Harrisburg, NC 28075, USA",
      "poi_short_description": "Park with playground, soccer fields and splash pads as well as picnic spots.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, walking track, and plenty of green space for picnics. They also highlight the clean restrooms, family-friendly atmosphere, and convenient parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-22d2-70b2-8944-43bb8de64c3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-22d2-70b2-8944-43bb8de64c3e",
        "storage_key": "property/6767906449166458/019d02ce-22d2-70b2-8944-43bb8de64c3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://harrisburgnc.org/facilities/facility/details/Harrisburg-Park-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=3780396150664018381&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harrisburg-park",
      "poi_latitude": "35.3179791",
      "poi_longitude": "-80.6599598",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-455-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-431a-7443-8f94-374b23fd8704.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-431a-7443-8f94-374b23fd8704",
        "storage_key": "property/6767906449166458/019d02ce-431a-7443-8f94-374b23fd8704.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw0T-0MaVIgRzTmVBkWqdjQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d1324247-8faa-4efd-9306-c4decbc3cca5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "UNC Charlotte Main Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9025 Cameron Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-2aef-756e-9e2d-89888ae32978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-2aef-756e-9e2d-89888ae32978",
        "storage_key": "property/6767906449166458/019d02ce-2aef-756e-9e2d-89888ae32978.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588625435149076740&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "unc-charlotte-main-station",
      "poi_latitude": "35.3121822",
      "poi_longitude": "-80.73371980000002",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTHpFBEcVIgRBAkeIW8R06A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_b7866f68-3645-41fd-8d55-8658406bc1a8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-2f59-7714-a43b-379069f21988.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-2f59-7714-a43b-379069f21988",
        "storage_key": "property/6767906449166458/019d02ce-2f59-7714-a43b-379069f21988.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_127747f6-6a46-4581-bcc2-8d5be95b5aef",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "McCullough",
      "poi_type": "Transportation & Transit",
      "poi_address": "8312 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-304d-765b-ad35-e5191df34fbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-304d-765b-ad35-e5191df34fbc",
        "storage_key": "property/6767906449166458/019d02ce-304d-765b-ad35-e5191df34fbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlottenc.gov/cats/rail/lynx-blue-line/Pages/mccullough-station.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1260187329938804696&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mccullough",
      "poi_latitude": "35.301124",
      "poi_longitude": "-80.752875",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_ReviccVIgR2E9zJ7MVfRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_71ae6bcc-10e1-41cc-84aa-f1741e2f28a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Hendrick Motorsports",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Papa Joe Hendrick Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Since 1984, this team has won a record 12 car owner championships in NASCAR’s premier division.",
      "poi_long_description": "Since 1984, this team has won a record 12 car owner championships in NASCAR’s premier division.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3277-764e-b21a-2b6163ce7167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-3277-764e-b21a-2b6163ce7167",
        "storage_key": "property/6767906449166458/019d02ce-3277-764e-b21a-2b6163ce7167.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hendrickmotorsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16390207286542690273&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hendrick-motorsports",
      "poi_latitude": "35.3546526",
      "poi_longitude": "-80.7044047",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-455-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-bK_2sbVIgR4WdlJbC2deM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_951a7daa-5ac1-46fa-a991-092b537e137a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14bf-aa9b-72de-b1a5-b482c7871851.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14bf-aa9b-72de-b1a5-b482c7871851",
        "storage_key": "property/6767906449166458/019f14bf-aa9b-72de-b1a5-b482c7871851.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_a4ea627e-4cec-492c-bd14-583c88f9bf3e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "CATS Bus Stop – N Tryon St & Mallard Creek Church Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "N Tryon St & Mallard Creek Church Rd, Charlotte, NC 28262",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_50cb5eb3-f13d-45a5-8c70-f6bd800fab10",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "CATS Bus Stop – University City Blvd & N Tryon St",
      "poi_type": "Transportation & Transit",
      "poi_address": "University City Blvd & N Tryon St, Charlotte, NC 28262",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ce0881fd-8f11-482c-96e1-7e4d2296c339",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Stoney Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "14015 Mallard Roost Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-39e5-774e-81ea-b3ee63cee93e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-39e5-774e-81ea-b3ee63cee93e",
        "storage_key": "property/6767906449166458/019f14d9-39e5-774e-81ea-b3ee63cee93e.webp",
        "width": 1200,
        "height": 570
      },
      "poi_business_url": "https://www.cmsk12.org/stoneycreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=16947952449494394279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stoney-creek-elementary-school",
      "poi_latitude": "35.3482805",
      "poi_longitude": "-80.7253375",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-344-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq8y7u4McVIgRpyVTbvU4M-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9f30cf1c-d9d8-40dd-ae51-ef4e77b93968",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "James Martin Middle School",
      "poi_type": "Education",
      "poi_address": "6301 University Pointe Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-48c0-726d-b5c7-88ec40dae2b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-48c0-726d-b5c7-88ec40dae2b3",
        "storage_key": "property/6767906449166458/019f14d9-48c0-726d-b5c7-88ec40dae2b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cmsk12.org/jamesmartinMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=5618926938611783760&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "james-martin-middle-school",
      "poi_latitude": "35.2994377",
      "poi_longitude": "-80.7661055",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-343-5382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsavmwH8eVIgRUBjUwkdw-k0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7cca8ff1-4876-4f66-bd04-de948e97ca18",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Julius L. Chambers High School",
      "poi_type": "Education",
      "poi_address": "7600 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-39e4-76a4-8997-a9f0c8c368cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-39e4-76a4-8997-a9f0c8c368cd",
        "storage_key": "property/6767906449166458/019f14d9-39e4-76a4-8997-a9f0c8c368cd.webp",
        "width": 413,
        "height": 275
      },
      "poi_business_url": "https://www.cmsk12.org/chambersHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17524243692802135939&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "julius-l-chambers-high-school",
      "poi_latitude": "35.3008041",
      "poi_longitude": "-80.76758769999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-343-5284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYSZQhk8mVIgRg9fZisqeMvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_00f53833-af3a-47af-9ace-dd78e5358b29",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Central Piedmont Community College - Cato Campus",
      "poi_type": "Education",
      "poi_address": "8120 Grier Rd, Charlotte, NC 28215, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-3dc1-751b-bf4e-4ed8e560d2ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-3dc1-751b-bf4e-4ed8e560d2ae",
        "storage_key": "property/6767906449166458/019f14d9-3dc1-751b-bf4e-4ed8e560d2ae.webp",
        "width": 1280,
        "height": 1043
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8472720393872062122&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-piedmont-community-college---cato-campus",
      "poi_latitude": "35.2647794",
      "poi_longitude": "-80.73136679999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d93-758f-b248-b6323d9c0a9a",
        "storage_key": "property/6767906449166458/019d02ce-3d93-758f-b248-b6323d9c0a9a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIe_03s8eVIgRqrbzzU4mlXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_acfd8606-9a60-48a1-965a-4ca893cbc0d9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Sarangi, Nepali / Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "9211 N Tryon St #13, Charlotte, NC 28262, USA",
      "poi_short_description": "Casual restaurant serving tandoori-fired dishes and other Indian classics, plus curry, biryani and tikkas.",
      "poi_long_description": "People say this Indian restaurant serves delicious momos, chicken lollipop, and chicken chowmein. They highlight the flavorful jhol momo sauce and the generous portions. They also like the reasonable prices and the kind, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-3a46-70cb-9928-1cb4ae365afd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-3a46-70cb-9928-1cb4ae365afd",
        "storage_key": "property/6767906449166458/019f14d9-3a46-70cb-9928-1cb4ae365afd.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://www.indian-food.restaurant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14057630354852348457&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sarangi-nepali--thai-cuisine",
      "poi_latitude": "35.3119976",
      "poi_longitude": "-80.7447091",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-526-0716",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZwRGiH8dVIgRKQK5xFO8FsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dab0a365-6ce7-44e5-9e81-1354dcb5227a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Le Kebab Grill",
      "poi_type": "Restaurants",
      "poi_address": "350 E McCullough Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "Middle Eastern wraps & sandwiches are prepared with halal meat at this casual counter-serve outfit.",
      "poi_long_description": "Diners like this restaurant's delicious and authentic Mediterranean food, with many highlighting the flavorful kebabs, shawarmas, and falafel, as well as generous portion sizes. They also mention the reasonable prices and the warm, welcoming atmosphere. Visitors consistently praise the friendly, attentive, and professional staff, noting their excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-47bb-707b-8c93-1fcda3a3bc54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-47bb-707b-8c93-1fcda3a3bc54",
        "storage_key": "property/6767906449166458/019f14d9-47bb-707b-8c93-1fcda3a3bc54.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lekebabgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17899477250669063360&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "le-kebab-grill",
      "poi_latitude": "35.3019409",
      "poi_longitude": "-80.7490463",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-547-7217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj1Sf1CYcVIgRwKxQV7m3Z_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "middle_eastern_restaurant"
    },
    {
      "id": "custom_5fb546d2-9f38-470d-b167-804689488331",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Anatolia Cafe & Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "1520 Overland Park Ln #107, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this restaurant offers delicious, fresh, and authentic Turkish cuisine, with popular dishes like lahmacun, kebabs, and borek. They also highlight the warm, welcoming, and clean atmosphere, along with excellent, friendly, and attentive service. Visitors appreciate the wide variety of coffee and dessert options, including pistachio-themed treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-3d6d-7558-9bce-93a5860fe392.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-3d6d-7558-9bce-93a5860fe392",
        "storage_key": "property/6767906449166458/019f14d9-3d6d-7558-9bce-93a5860fe392.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://anatoliacafeandcuisine.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=5003888520863778677&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "anatolia-cafe--cuisine",
      "poi_latitude": "35.31769999999999",
      "poi_longitude": "-80.77188",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-619-8237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d96-73de-87c5-cb9ed015471d",
        "storage_key": "property/6767906449166458/019d02ce-3d96-73de-87c5-cb9ed015471d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ69Xa0FgdVIgRdYe9FRlicUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_09d30510-53e0-45ee-8b0a-4603788cae52",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Belgate Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7105 University City Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Huge shopping center with well-known furniture, clothing & footwear stores, plus casual eateries.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and furniture. They also highlight the good prices, convenient parking, and spacious layout.\n\nOther reviews mention the store can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-4030-73e2-b996-517c24dcc6ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-4030-73e2-b996-517c24dcc6ae",
        "storage_key": "property/6767906449166458/019f14d9-4030-73e2-b996-517c24dcc6ae.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://belgate-shopping-center.website/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13087093934791420873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belgate-shopping-center",
      "poi_latitude": "35.2903841",
      "poi_longitude": "-80.763172",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc7nFnYceVIgRyWtpZZiynrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7090645e-902f-40bb-80a7-b3bdb10eab9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Terraces at University Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "9605 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "Popular shopping center and plaza housing a variety of stores, restaurants and salons.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-3fba-7453-afbf-e2b3757f6dba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-3fba-7453-afbf-e2b3757f6dba",
        "storage_key": "property/6767906449166458/019f14d9-3fba-7453-afbf-e2b3757f6dba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1197177428147067676&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "terraces-at-university-place",
      "poi_latitude": "35.3171457",
      "poi_longitude": "-80.74002519999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 843-724-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-3d99-74d0-b9a1-8676410fc43b",
        "storage_key": "property/6767906449166458/019d02ce-3d99-74d0-b9a1-8676410fc43b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPS4I-BQcVIgRHFvSKYc6nRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ba492c40-10a6-409e-a5d0-6cff5ba30ab8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Keith Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8100 Old Mallard Creek Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Offering programs and services for all ages and abilities, this youth center has a pool, and gym.",
      "poi_long_description": "Some people say this youth center offers day camp and swimming lessons.\n\nOther reviews mention customer service can be disappointing and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-3a9e-73df-85fc-407974c4cdcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-3a9e-73df-85fc-407974c4cdcd",
        "storage_key": "property/6767906449166458/019f14d9-3a9e-73df-85fc-407974c4cdcd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ymcacharlotte.org/locations/keith-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9660733629701512364&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "keith-family-ymca",
      "poi_latitude": "35.3160647",
      "poi_longitude": "-80.77850409999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-716-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_l4NMQdVIgRrFwHLA3SEYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d63e83fd-7a23-4067-b4aa-29caaf992232",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Vitality Chiropractic & Acupuncture",
      "poi_type": "Health and Wellness",
      "poi_address": "10320 Mallard Creek Rd Ste 210, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-47e8-705b-9cba-6bbfc952df39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-47e8-705b-9cba-6bbfc952df39",
        "storage_key": "property/6767906449166458/019f14d9-47e8-705b-9cba-6bbfc952df39.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://vitality-chiro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379900817258344433&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vitality-chiropractic--acupuncture",
      "poi_latitude": "35.3402234",
      "poi_longitude": "-80.7679015",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-226-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeOgCG4dVIgR8W_ouv31iVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "custom_32adea3b-4398-480c-8931-3f3d498b6527",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Susie Harwood Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Relaxed, well maintained campus spot known for its variety of plants and peaceful ambiance.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-48b9-7662-9132-c9f88713d958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-48b9-7662-9132-c9f88713d958",
        "storage_key": "property/6767906449166458/019f14d9-48b9-7662-9132-c9f88713d958.webp",
        "width": 1200,
        "height": 801
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12756979194540810461&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "susie-harwood-garden",
      "poi_latitude": "35.3084563",
      "poi_longitude": "-80.7287215",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-687-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_EBZA8cVIgR3WCn8fzkCbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_a66a0562-05c6-41b2-b736-1ee1b26c239e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Toby Creek Greenway - Ruth G. Shaw Trailhead (2 miles)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8541 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-4c6e-733f-8bfe-6590f5ad5aad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-4c6e-733f-8bfe-6590f5ad5aad",
        "storage_key": "property/6767906449166458/019f14d9-4c6e-733f-8bfe-6590f5ad5aad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carolinathreadtrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13519428957779332624&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "toby-creek-greenway---ruth-g-shaw-trailhead-2-miles",
      "poi_latitude": "35.2968741",
      "poi_longitude": "-80.7414333",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-376-2556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73PsZ6AeVIgREA6REgKpnrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_08be0354-2120-46f1-b9a2-866101117754",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-4c4a-750f-bf05-8b2862dccb4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-4c4a-750f-bf05-8b2862dccb4a",
        "storage_key": "property/6767906449166458/019f14d9-4c4a-750f-bf05-8b2862dccb4a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_0d8b55bc-41d5-4fe1-bfce-0c46f021e832",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Clarks Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9729 Mallard Creek Rd, Charlotte, NC 28267, USA",
      "poi_short_description": "This 7-mile trail with a wooded creekside setting attracts bikers, runners & skateboarders.",
      "poi_long_description": "Visitors say this greenway offers paved paths for walking, running, or biking, with a beautiful creek and abundant natural scenery. They also highlight the extensive shade provided by the tree canopy, making it a comfortable experience. Guests mention the tranquil atmosphere and the availability of parking, often near a school.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-5099-732d-9920-cba94047de0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-5099-732d-9920-cba94047de0b",
        "storage_key": "property/6767906449166458/019f14d9-5099-732d-9920-cba94047de0b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285017145315421591&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clarks-creek-greenway",
      "poi_latitude": "35.3345362",
      "poi_longitude": "-80.7740029",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEWo_U0gcVIgRl-3jjGiTPsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_ca3e5abf-e90a-4c11-bc20-0fd597bde99b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Van Landingham Glen",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-4fb1-723c-b294-9034d04033a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-4fb1-723c-b294-9034d04033a5",
        "storage_key": "property/6767906449166458/019f14d9-4fb1-723c-b294-9034d04033a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2224722489488567839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "van-landingham-glen",
      "poi_latitude": "35.3066155",
      "poi_longitude": "-80.7280005",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-431a-7443-8f94-374b23fd8704.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-431a-7443-8f94-374b23fd8704",
        "storage_key": "property/6767906449166458/019d02ce-431a-7443-8f94-374b23fd8704.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1cZwgUcVIgRH-7JLVHN3x4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cbf83131-f0b8-45db-aca2-3d581f32d282",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Monster Mini Golf Charlotte",
      "poi_type": "Entertainment",
      "poi_address": "230 E W.T. Harris Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Monster-themed mini-golf chain featuring a glow-in-the-dark indoor course, plus arcade games & a DJ.",
      "poi_long_description": "People say this mini golf course offers a unique glow-in-the-dark experience with fun animatronics and a variety of arcade games and mini bowling. Visitors also highlight the reasonable prices and the clean, well-maintained facilities. Guests mention the staff are consistently friendly, helpful, and engaging, enhancing the overall fun atmosphere for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-4e89-7119-a470-e4bb61f45999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-4e89-7119-a470-e4bb61f45999",
        "storage_key": "property/6767906449166458/019f14d9-4e89-7119-a470-e4bb61f45999.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://monsterminigolf.com/locations/us/nc/charlotte/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16996487887131415599&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "monster-mini-golf-charlotte",
      "poi_latitude": "35.3035896",
      "poi_longitude": "-80.7491079",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 980-246-8896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ37C0M3odVIgRL5Syna6n3-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_27e0c4b7-65da-4c2f-b388-a043cfe6a035",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Allstate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7349 IBM Dr, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-5036-73c8-a1e2-fadfe6ec0d7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-5036-73c8-a1e2-fadfe6ec0d7f",
        "storage_key": "property/6767906449166458/019f14d9-5036-73c8-a1e2-fadfe6ec0d7f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://agents.allstate.com/usa/nc/charlotte",
      "poi_directions_map_url": "https://maps.google.com/?cid=13327792766388619228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "allstate",
      "poi_latitude": "35.3068174",
      "poi_longitude": "-80.7698411",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 847-402-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb_ULy8UdVIgR3EedSOjU9bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ec614e0a-e38f-4444-855e-3eda44824233",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "TIAA Financial Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8500 Andrew Carnegie Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-55ab-748e-84fc-2d468397030a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-55ab-748e-84fc-2d468397030a",
        "storage_key": "property/6767906449166458/019f14d9-55ab-748e-84fc-2d468397030a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tiaa.org/public/index.html?tc_mcid=bn_yextglocal_0618",
      "poi_directions_map_url": "https://maps.google.com/?cid=12721819279398748753&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tiaa-financial-services",
      "poi_latitude": "35.3236604",
      "poi_longitude": "-80.7511318",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 877-535-3910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ995F40YcVIgRUUJHRTv7jLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_f680b650-a9a7-48c8-8614-fe5745d87a55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Duke Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "525 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f14d9-52f4-77b8-986e-400addb144cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14d9-52f4-77b8-986e-400addb144cb",
        "storage_key": "property/6767906449166458/019f14d9-52f4-77b8-986e-400addb144cb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.duke-energy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821899997112668324&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "duke-energy",
      "poi_latitude": "35.2236874",
      "poi_longitude": "-80.84766309999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-774-1226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-42ec-727d-ac5c-cff96f78a525",
        "storage_key": "property/6767906449166458/019d02ce-42ec-727d-ac5c-cff96f78a525.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeckepVqhVogRpJD3TswdCjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2cd9647f-abb5-4f99-9afb-e2af11b1ef81",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "Atrium Health University City",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 N Tryon St, Charlotte, NC 28262",
      "poi_short_description": "Major regional hospital employing physicians, nurses, allied health professionals, and administrative staff.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_16e22582-ab4b-478a-a76a-f6df12e6c730",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "poi_name": "UNC Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City blvd",
      "poi_short_description": "The area's largest employer, with thousands of faculty, staff, researchers, and student employees",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b5c59d9e1042b79f57412397",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_038d5c9383544d282f963c6b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1139494e62feb0adcdd3b90c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6fb91cc8c34035985b12d683",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_5cc6344624da906c4830c8e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_10113b993aee2e5e20b8fec6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_258d3b03-d490-4f7e-968c-7cbcdc8b1666",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "rating": "5.0",
      "name": "Kendra Briggs",
      "text": "My walk-in/ touring experience here was nothing less of welcoming! As soon as I walked in Sheldon knew exactly what I was looking for and was ready to get straight to it. The whole office staff was so helpful and already felt like home. Sheldon made sure to answer every questions and top of the head concerns that I had. The apartment(s) looked beautiful! Online was givin but in person was so much better. Sheldon gave me the opportunity to apply in the office and helped me through every step I needed. I definitely recommend checking this place out.",
      "date": "2025-10-03",
      "title": ""
    },
    {
      "id": "custom_c587bb8f-8205-492f-9257-d33af3715e71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "rating": "5.0",
      "name": "Brittany White",
      "text": "I’ve had such a great experience living here! The community is well-kept, safe, and has everything I need. I especially want to mention Sheldon and Angel — they go above and beyond to make sure residents feel welcome and taken care of. They’re always professional, kind, and quick to help whenever something comes up. Truly a great team that makes this place feel like home!",
      "date": "2025-09-12",
      "title": ""
    },
    {
      "id": "custom_0f96dc26-871d-434d-9b8d-4b6cfa6effd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "rating": "5.0",
      "name": "Arielle Brianna",
      "text": "Me and roommate went to tour at the willows at university and Sheldon provided us with exceptional customer service!!!! When we arrived he was taking a call on the phone, yet very attentive! He waved and acknowledged us making us feel welcomed! While we toured he was very in depth with everything and very accommodating! He provided us with all the information we needed and answered any questions we had. All of the staff was very friendly which you don’t see a lot these days. His attitude and energy was amazing and the tour was lovely! 10/10 highly recommend!",
      "date": "2025-06-26",
      "title": ""
    },
    {
      "id": "custom_5d31a2a1-04fa-4b77-9b63-45d6c53c828e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "rating": "5.0",
      "name": "Javott Hampton",
      "text": "Ever since Sheldon joined our community I get to see a welcoming smile every time I walk into the office. He makes my questions & concerns felt heard while also maintaining he strong professionalism and personality. I love going to Sheldon…please stay at the Willows because you are most definitely needed. Your tenant Javott",
      "date": "2025-08-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8d69bff0-3ad4-4633-ac2b-6c62e2e08625",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f6c19-5ff4-7504-b23f-81452eec5afd.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-5ff4-7504-b23f-81452eec5afd",
        "storage_key": "property/6767906449166458/019f6c19-5ff4-7504-b23f-81452eec5afd.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ZDixg8cm66x"
    },
    {
      "id": "custom_27cac635-9291-414f-bb25-ece12f0601c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019f6c19-5f16-749e-9881-91072775e0ed.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c19-5f16-749e-9881-91072775e0ed",
        "storage_key": "property/6767906449166458/019f6c19-5f16-749e-9881-91072775e0ed.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hSoKFpHHPLC"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e019-4c35-7512-8795-3f430a76ffab",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-willows-at-the-university-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-charlotte-nc",
      "search_query": "pet friendly apartments charlotte nc",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Charlotte, NC",
      "h2_subtitle": "Discover pet friendly apartments in Charlotte, NC. Willows at the University welcomes you and your furry friends with open paws.",
      "page_copy": "Finding the perfect home for you and your pet has never been easier than at Willows at the University. Our pet friendly apartments in Charlotte, NC, are designed with both you and your furry family members in mind. With spacious floor plans and pet-friendly amenities like our expansive parks, you and your pet will love calling this vibrant community home.\n\nEnjoy a lifestyle that accommodates both you and your pets with modern amenities such as a resort-style pool and fitness center. Our commitment to providing a welcoming environment extends to all residents, including the four-legged ones. Schedule a tour today and see why Willows at the University is the premier pet-friendly apartment community in Charlotte, NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Charlotte, NC",
      "seo_description": "Explore pet friendly apartments in Charlotte, NC at Willows at the University. Spacious layouts with amenities await you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "university-area-apartments-in-unit-laundry",
      "search_query": "university area apartments with in unit laundry",
      "category": "Amenity",
      "h1_title": "University Area Apts with In-Unit Laundry",
      "h2_subtitle": "Discover university area apartments with in-unit laundry. Enjoy the convenience and comfort at Willows at the University.",
      "page_copy": "At Willows at the University, we offer convenient university area apartments with in-unit laundry options in Charlotte, NC. Experience the perfect blend of comfort and practicality with our modern one, two, or three-bedroom floor plans. Each apartment is equipped with a washer and dryer, making laundry days a breeze in the comfort of your own home.\n\nLocated in the vibrant neighborhood of Mallard Creek - Withrow Downs, our apartments provide easy access to the local university and other amenities. In addition to in-unit laundry, residents enjoy upscale features like air conditioning, heating, and 24-hour access. Embrace a stress-free lifestyle today by joining our welcoming community at Willows at the University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "University Area Apts with In-Unit Laundry",
      "seo_description": "Find university area apartments with in-unit laundry at Willows at the University. Enjoy modern living with convenient amenities in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "poolside-apartments-mallard-creek",
      "search_query": "poolside apartments in mallard creek",
      "category": "Amenity",
      "h1_title": "Poolside Apartments in Mallard Creek",
      "h2_subtitle": "Enjoy poolside living in Mallard Creek. Discover apartments with resort-style amenities at Willows at the University.",
      "page_copy": "Immerse yourself in the relaxing poolside ambiance at Willows at the University, where our poolside apartments in Mallard Creek await. Offering a resort-style pool, these apartments provide a perfect setting for both relaxation and socializing. Experience the luxury of having a refreshing retreat right at your doorstep, only steps away from your stylish home.\n\nBeyond the pool, you'll find our community equipped with other upscale amenities like a modern fitness center and pet-friendly parks, ensuring every aspect of your lifestyle is catered to. Nestled in the vibrant Mallard Creek - Withrow Downs neighborhood, Willows at the University is the ideal choice for those seeking premium poolside apartments in Charlotte, NC. Schedule a visit today and see what makes our community special.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments in Mallard Creek",
      "seo_description": "Discover poolside apartments in Mallard Creek at Willows at the University. Enjoy resort-style living with modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-28262",
      "search_query": "fitness center apartments 28262",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 28262",
      "h2_subtitle": "Find fitness center apartments in Charlotte's 28262. Willows at the University offers the perfect blend of modern living and active lifestyle.",
      "page_copy": "Achieve your fitness goals without leaving home at Willows at the University, where our fitness center apartments in the 28262 area blend convenience with modern living. Our state-of-the-art fitness center is open 24 hours, offering the flexibility you need to maintain your workout routine, regardless of your busy schedule.\n\nLocated in the vibrant city of Charlotte, NC, and in the heart of the Mallard Creek - Withrow Downs neighborhood, our community offers more than just top-notch fitness facilities. Residents enjoy stylish one, two, and three-bedroom apartments with upscale amenities including air conditioning, in-unit laundry, and a resort-style pool. Join our dynamic community and experience the best of fitness and modern living at Willows at the University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 28262",
      "seo_description": "Explore fitness center apartments in 28262 at Willows at the University. Enjoy a convenient lifestyle with modern amenities in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "willows-university-granite-countertops",
      "search_query": "willows at the university granite countertops",
      "category": "Amenity",
      "h1_title": "Willows at the University Granite Countertops",
      "h2_subtitle": "Explore Willows at the University with granite countertops. Discover upscale living with modern finishes in Charlotte, NC.",
      "page_copy": "Experience upscale living at Willows at the University, where granite countertops enhance the elegance and functionality of our stylish apartments. Offering a blend of sophistication and practicality, these countertops are a key feature in our modern one, two, and three-bedroom floor plans.\n\nNestled in the vibrant Mallard Creek - Withrow Downs neighborhood, our Charlotte community goes beyond beautiful interiors. Residents can enjoy luxurious amenities such as a resort-style pool, a cutting-edge fitness center, and pet-friendly parks. Embrace a refined lifestyle at Willows at the University, where the beauty of granite countertops is just the beginning of what you'll love about living here.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Willows at the University Granite Countertops",
      "seo_description": "Discover Willows at the University with granite countertops. Enjoy modern living and upscale amenities in Charlotte's Mallard Creek neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mallard-creek-withrow-downs",
      "search_query": "one bedroom apartments near Mallard Creek Withrow Downs",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Mallard Creek",
      "h2_subtitle": "Discover one bedroom apartments near Mallard Creek Withrow Downs. Experience modern living at Willows at the University.",
      "page_copy": "Find your perfect home at Willows at the University with our one bedroom apartments near Mallard Creek Withrow Downs. Designed for comfort and style, each apartment boasts a spacious layout complemented by upscale finishes and amenities.\n\nLocated in a vibrant area of Charlotte, NC, our community offers more than just a place to live. Residents enjoy exclusive access to features such as a resort-style pool, fitness center, and pet-friendly areas, ensuring every lifestyle need is met. Embrace the convenience of living in the Mallard Creek neighborhood while relishing the modern comforts and community spirit at Willows at the University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Mallard Creek",
      "seo_description": "Explore one bedroom apartments near Mallard Creek Withrow Downs at Willows at the University. Enjoy modern amenities and a lively Charlotte community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-mecklenburg-county",
      "search_query": "two bedroom apartments in Mecklenburg County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Mecklenburg County",
      "h2_subtitle": "Explore two bedroom apartments in Mecklenburg County at Willows at the University. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Discover spacious two bedroom apartments in Mecklenburg County at Willows at the University, where stylish living meets unbeatable convenience. Each apartment features thoughtful layouts designed to enhance your lifestyle, complete with upscale amenities and modern finishes that truly elevate your living experience.\n\nNestled within the Mallard Creek - Withrow Downs neighborhood in Charlotte, NC, our community boasts perks beyond your apartment walls, such as access to a resort-style pool, a fully-equipped fitness center, and pet-friendly parks. These features make Willows at the University an ideal choice for those seeking comfort and community spirit in Mecklenburg County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Mecklenburg County",
      "seo_description": "Discover two bedroom apartments in Mecklenburg County at Willows at the University. Enjoy modern living and amenities in Charlotte, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-charlotte-nc-28262",
      "search_query": "three bedroom apartments in Charlotte NC 28262",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Charlotte, NC 28262",
      "h2_subtitle": "Find three bedroom apartments in Charlotte, NC 28262 at Willows at the University. Spacious layouts and modern amenities await you.",
      "page_copy": "Explore generous living spaces with the three bedroom apartments in Charlotte, NC 28262 at Willows at the University. Designed with families and roommates in mind, each apartment offers roomy interiors complemented by high-end amenities, ensuring you live comfortably and stylishly.\n\nLocated in the vibrant Mallard Creek - Withrow Downs area, our community provides more than just a home. Enjoy amenities like a resort-style pool, a state-of-the-art fitness center, and welcoming pet-friendly parks. At Willows at the University, you can experience the convenience of Charlotte living with the added benefit of a supportive community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Charlotte, NC 28262",
      "seo_description": "Explore three bedroom apartments in Charlotte, NC 28262 at Willows at the University. Enjoy spacious living and modern community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-north-carolina-charlotte",
      "search_query": "apartments near university of north carolina charlotte",
      "category": "School",
      "h1_title": "Apartments Near University of North Carolina Charlotte",
      "h2_subtitle": "Discover apartments near University of North Carolina Charlotte at Willows at the University. Enjoy modern comforts in a prime location.",
      "page_copy": "If you're searching for apartments near the University of North Carolina Charlotte, look no further than Willows at the University. Our apartments offer stylish living just a stone's throw away from campus, making it an ideal choice for students, staff, and faculty alike.\n\nSituated in the lively Mallard Creek - Withrow Downs area, our community provides residents with top-tier amenities such as a resort-style pool, fitness center, and pet-friendly spaces. With our convenient location and modern delights, Willows at the University is the perfect blend of academic convenience and relaxed apartment living in Charlotte, NC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of North Carolina Charlotte",
      "seo_description": "Find modern apartments near University of North Carolina Charlotte at Willows at the University. Experience stylish living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-close-to-bradford-preparatory-school",
      "search_query": "apartments close to bradford preparatory school mecklenburg county",
      "category": "School",
      "h1_title": "Apartments Close to Bradford Preparatory School",
      "h2_subtitle": "Explore apartments close to Bradford Preparatory School in Mecklenburg County. Enjoy community and convenience at Willows at the University.",
      "page_copy": "For those seeking apartments close to Bradford Preparatory School in Mecklenburg County, Willows at the University offers modern, convenient living spaces designed for families and professionals alike. Each apartment is thoughtfully crafted with spacious floor plans and upscale amenities, ideal for anyone seeking easy access to nearby educational institutions.\n\nLocated in the community-focused neighborhood of Mallard Creek - Withrow Downs, our residents benefit from convenient amenities such as a resort-style pool, a state-of-the-art fitness center, and beautiful, pet-friendly parks. Experience the perfect blend of location and lifestyle at Willows at the University, where proximity to Bradford Preparatory School is just one of the many conveniences offered.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Bradford Preparatory School",
      "seo_description": "Discover apartments close to Bradford Preparatory School in Mecklenburg County at Willows at the University. Convenient living near educational hubs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-atrium-health-university-city",
      "search_query": "apartments near Atrium Health University City Charlotte",
      "category": "Hospital",
      "h1_title": "Apartments Near Atrium Health University City",
      "h2_subtitle": "Find apartments near Atrium Health University City Charlotte at Willows at the University. Convenience and comfort in one location.",
      "page_copy": "Discover the perfect blend of comfort and convenience with apartments near Atrium Health University City in Charlotte at Willows at the University. Perfect for healthcare professionals and hospital staff, our community provides easy access to work while offering a peaceful retreat after hours.\n\nSituated in the vibrant Mallard Creek - Withrow Downs neighborhood, our residents enjoy premium amenities such as a resort-style pool, modern fitness center, and lush pet-friendly parks. Experience stylish, spacious floor plans that cater to all your needs at Willows at the University, making it an ideal home base near Atrium Health University City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Atrium Health University City",
      "seo_description": "Explore apartments near Atrium Health University City Charlotte at Willows at the University. Convenient and stylish living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-arthritis-knee-pain-centers-north",
      "search_query": "apartments close to Arthritis Knee Pain Centers North Charlotte Mecklenburg County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Arthritis Knee Pain Centers North",
      "h2_subtitle": "Discover apartments close to Arthritis Knee Pain Centers North Charlotte. Enjoy modern living with great access.",
      "page_copy": "Willows at the University offers exceptional apartments close to Arthritis Knee Pain Centers North in Charlotte, Mecklenburg County. Ideal for medical professionals and patients seeking a convenient residence, our community is designed with ease in mind.\n\nNestled in the Mallard Creek - Withrow Downs neighborhood, Willows at the University boasts impressive features like a resort-style pool, cutting-edge fitness center, and dog-friendly parks. Find the perfect combination of location and lifestyle with our spacious floor plans and upscale amenities, all just minutes from Arthritis Knee Pain Centers North.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Arthritis Knee Pain Centers North",
      "seo_description": "Find apartments close to Arthritis Knee Pain Centers North Charlotte at Willows at the University. Convenient location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-frank-liske-park-charlotte",
      "search_query": "apartments near Frank Liske Park Charlotte",
      "category": "Park",
      "h1_title": "Apartments Near Frank Liske Park Charlotte",
      "h2_subtitle": "Explore apartments near Frank Liske Park in Charlotte and discover vibrant community living at Willows at the University.",
      "page_copy": "Experience the joy of living near nature with apartments near Frank Liske Park in Charlotte. Willows at the University provides ideal accommodations for those who love outdoor activities and scenic beauty, with easy access to this popular local park.\n\nOur community resides in the welcoming Mallard Creek - Withrow Downs area, offering spacious, modern amenities, including a resort-style pool, fitness center, and dog-friendly parks. Whether you're a nature enthusiast or looking for a peaceful escape after a busy week, Willows at the University offers the perfect setting close to Frank Liske Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Frank Liske Park Charlotte",
      "seo_description": "Discover apartments near Frank Liske Park in Charlotte at Willows at the University. Enjoy modern living near natural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-close-to-reedy-creek-park-mallard-creek",
      "search_query": "apartments close to Reedy Creek Park Mallard Creek",
      "category": "Park",
      "h1_title": "Apartments Close to Reedy Creek Park",
      "h2_subtitle": "Find apartments close to Reedy Creek Park in Mallard Creek for a nature-friendly lifestyle with modern comforts.",
      "page_copy": "Willows at the University presents prime apartments close to Reedy Creek Park in Mallard Creek. Perfect for anyone who appreciates natural beauty and outdoor activities, our community offers both convenient access to the park and luxurious amenities.\n\nLocated in the vibrant Mallard Creek - Withrow Downs neighborhood, residents at Willows at the University enjoy a selection of one, two, or three-bedroom layouts, a resort-style pool, state-of-the-art fitness center, and pet-friendly areas. Embrace a fulfilling lifestyle that brings you close to the serenity of Reedy Creek Park and the conveniences of city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Reedy Creek Park Mallard Creek",
      "seo_description": "Explore apartments close to Reedy Creek Park in Mallard Creek at Willows at the University. Enjoy the balance of natural beauty and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-harrisburg-park-mecklenburg-county",
      "search_query": "apartments near Harrisburg Park Mecklenburg County",
      "category": "Park",
      "h1_title": "Apartments Near Harrisburg Park",
      "h2_subtitle": "Discover apartments near Harrisburg Park in Mecklenburg County and enjoy access to both nature and modern amenities.",
      "page_copy": "Escape to the tranquility of Mecklenburg County with apartments near Harrisburg Park at Willows at the University. Perfect for those who value outdoor recreation and contemporary living, our community offers the ideal home base.\n\nSituated in the charming Mallard Creek - Withrow Downs neighborhood, Willows at the University provides a variety of spacious floor plans and luxurious features like a resort-style pool and modern fitness center. Enjoy the convenience of being near Harrisburg Park while relishing upscale living with pet-friendly parks and private patios.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harrisburg Park Mecklenburg County",
      "seo_description": "Find your perfect home near Harrisburg Park in Mecklenburg County at Willows at the University. Enjoy modern living with outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-close-to-unc-charlotte-botanical-gardens-28262",
      "search_query": "apartments close to UNC Charlotte Botanical Gardens 28262",
      "category": "Park",
      "h1_title": "Apartments Close to UNC Charlotte Gardens",
      "h2_subtitle": "Explore apartments close to UNC Charlotte Botanical Gardens in 28262, offering a serene lifestyle with modern conveniences.",
      "page_copy": "Located in the heart of the 28262 area, Willows at the University provides ideal apartments close to the UNC Charlotte Botanical Gardens. Perfect for plant lovers and those who appreciate serene surroundings, our community combines nature proximity with modern amenities.\n\nResiding in the vibrant Mallard Creek - Withrow Downs neighborhood, our apartments feature a selection of spacious floor plans and exceptional amenities, such as a resort-style pool, fitness center, and patios. Enjoy easy access to the beauty of the botanical gardens while indulging in upscale living that welcomes pets and offers comfort at every turn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UNC Charlotte Gardens 28262",
      "seo_description": "Live near the UNC Charlotte Botanical Gardens in 28262 at Willows at the University. Enjoy tranquility and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-unc-charlotte-main-station",
      "search_query": "apartments near UNC Charlotte Main Station",
      "category": "Transit",
      "h1_title": "Apartments Near UNC Charlotte Station",
      "h2_subtitle": "Discover the convenience of living near UNC Charlotte Main Station with our thoughtfully designed apartments offering modern amenities.",
      "page_copy": "At Willows at the University, we offer apartments near UNC Charlotte Main Station, providing an unbeatable location for students and professionals alike. Enjoy easy access to campus and the vibrant local scene while experiencing premium living conditions.\n\nSituated within the bustling Mallard Creek - Withrow Downs area, our community presents a mix of stylish one, two, and three-bedroom floor plans equipped with resort-style features. Residents relish amenities such as a sparkling pool, a cutting-edge fitness center, and washer/dryer facilities. Live close to UNC Charlotte Main Station while indulging in a lifestyle that blends accessibility with luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UNC Charlotte Station",
      "seo_description": "Find lifestyle convenience near UNC Charlotte Main Station at Willows at the University with modern amenities and proximity to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-city-blvd-charlotte",
      "search_query": "apartments close to University City Blvd Charlotte",
      "category": "Transit",
      "h1_title": "Apartments Close to University City Blvd",
      "h2_subtitle": "Experience the convenience of living close to University City Blvd in Charlotte with our stylish and amenity-rich apartments.",
      "page_copy": "Willows at the University offers prime apartments close to University City Blvd in Charlotte, providing you with unmatched accessibility to key destinations and daily conveniences. The bustling energy of this location ensures residents never miss out on the vibrant city life while enjoying a peaceful community environment.\n\nNestled in the lively Mallard Creek - Withrow Downs area, our community features modern one, two, and three-bedroom layouts complemented by high-end amenities. Residents appreciate touches like a resort-style pool, a fully-equipped fitness center, and expansive patios. With University City Blvd just around the corner, you can easily balance city excitement with a relaxed residential lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University City Blvd",
      "seo_description": "Discover upscale living close to University City Blvd in Charlotte at Willows at the University. Enjoy easy access to city life and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166458",
      "source": "generator",
      "page_item_url": "apartments-near-mccullough-mallard-creek",
      "search_query": "apartments near McCullough Mallard Creek",
      "category": "Transit",
      "h1_title": "Apartments Near McCullough Mallard Creek",
      "h2_subtitle": "Find your perfect home near McCullough Mallard Creek, where stylish apartments meet an active and connected community.",
      "page_copy": "Discover the ideal blend of comfort and convenience with our apartments near McCullough Mallard Creek. Located in the heart of Mecklenburg County, Willows at the University offers easy access to shopping, dining, and entertainment options while providing a serene living experience.\n\nOur community, set in the vibrant Mallard Creek - Withrow Downs neighborhood, features expansive one, two, and three-bedroom floor plans enhanced with luxury amenities. Enjoy a resort-style pool, state-of-the-art fitness center, and pet-friendly parks. Celebrate living close to McCullough Mallard Creek, where a balanced lifestyle awaits you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse at a multifamily property.",
        "public_id": "019d02cd-e3d3-72a4-8c68-b2f07ca49601",
        "storage_key": "property/6767906449166458/019d02cd-e3d3-72a4-8c68-b2f07ca49601.webp",
        "width": 650,
        "height": 433
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near McCullough Mallard Creek",
      "seo_description": "Explore living near McCullough Mallard Creek at Willows at the University. An ideal location with modern living and easy community access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5331"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425814"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=49fdb638ad3ad63cf0009f6c913f2ad3c6b85ea60d76c12cd16ed983515230dcc91ca1ee7360fbf99d34fdfd6952ab54\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PLNSFFFX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "997WUN"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40249052687"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "273520"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Willows at the University/scheduletourwidget/bifIWzhITM4Dlxu2Eo/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjdlaDcyZ1o0VW5nMjFLUW1qTlF1REE9PSIsInZhbHVlIjoiTnRQaEViaFVLRzZnYnJISzVWZEEwZz09IiwibWFjIjoiY2Y5ZGYwNWE5NTBhZmY5OTY2N2I3NGNmOTFiMzNmMjE1NDFlYmU5OTgxMzk2MTk5YmJkZmUxODhlZjRlM2I1OSJ9"
    }
  ],
  "custom_qb_id": "5331",
  "custom_repli_id": "18104425814",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=49fdb638ad3ad63cf0009f6c913f2ad3c6b85ea60d76c12cd16ed983515230dcc91ca1ee7360fbf99d34fdfd6952ab54\"></script>",
  "custom_google_gtm_id": "GTM-PLNSFFFX",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "997WUN",
  "custom_hubspot_company_id": "40249052687",
  "custom_broker_license_number": "273520",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Willows at the University/scheduletourwidget/bifIWzhITM4Dlxu2Eo/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjdlaDcyZ1o0VW5nMjFLUW1qTlF1REE9PSIsInZhbHVlIjoiTnRQaEViaFVLRzZnYnJISzVWZEEwZz09IiwibWFjIjoiY2Y5ZGYwNWE5NTBhZmY5OTY2N2I3NGNmOTFiMzNmMjE1NDFlYmU5OTgxMzk2MTk5YmJkZmUxODhlZjRlM2I1OSJ9",
  "custom_audioeye_site_id": "e90268c1-ab88-40a6-9fae-9a4158fffb3c",
  "custom_audioeye_site_hash": "31b311e591729e8cc513c206b5c1f223"
};

export const generatedAt = '2026-08-24T16:58:40.644Z';
